@if (label) {
  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
    {{ label }} @if (control && control.hasValidator(Validators.required)) {
    <span class="text-red-600">*</span>
  }
  </label>
}

<div (click)="$event.stopPropagation(); toggleOpen()" class="relative overflow-visible flex flex-col cursor-pointer" [ngClass]="{'cursor-not-allowed opacity-50': loading}">
  <div
    class="shadow-theme-xs focus:border-brand-300 focus:shadow-focus-ring dark:focus:border-brand-300 flex rounded-lg
  border border-gray-300 overflow-x-hidden h-auto pr-2 pl-3 outline-hidden transition dark:border-gray-700 dark:bg-gray-900 overflow-visible"
    [ngClass]="'min-h-' + height"
  >
    <div class="py-2 flex flex-auto items-start flex-wrap gap-2">
      @if (selectedOptions().length > 3) {
        <div class="group flex items-center justify-center py-1 text-sm text-gray-800">
          <div class="max-w-full flex-initial">{{ selectedOptions().length }} selected</div>
        </div>
      } @else {
        @for (option of selectedOptions(); track option.id) {
          <div
            [ngClass]="{'rounded-full border-[0.7px] pr-2 pl-2.5 border-transparent bg-gray-100 hover:border-gray-200 dark:bg-gray-800 dark:text-white/90 dark:hover:border-gray-800': multiple, }"
            class="group flex items-center justify-center py-1 text-sm text-gray-800 ">
            <div class="max-w-full flex-initial">{{ option.label }}</div>
            @if (multiple) {
              <div class="flex flex-auto flex-row-reverse">
                <div (click)="$event.stopPropagation();deselect(option.id)" class="cursor-pointer pl-2 text-gray-500 group-hover:text-gray-800 dark:text-gray-400">
                  <lucide-icon size="16" [name]="XIcon"></lucide-icon>
                </div>
              </div>
            }
          </div>
        }
      }
      @if (!selectedValues() || selectedValues().length == 0 && placeholder) {
        <div
          class="group flex items-center justify-center py-1 text-sm text-gray-800 border-0 bg-transparent p-1 pr-2 outline-hidden placeholder:text-gray-800 focus:border-0 focus:ring-0 focus:outline-hidden dark:placeholder:text-white/90">
          {{ placeholder }}
        </div>
      }
    </div>
    <div class="flex items-center gap-1">
      @if (hasSelectedOptions()) {
        <button type="button"
                (click)="$event.stopPropagation(); clearAll()"
                class="cursor-pointer text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300"
                [attr.disabled]="loading ? true : null">
          <lucide-icon size="16" [name]="XCircleIcon"></lucide-icon>
        </button>
      }
      <button type="button"
              (click)="$event.stopPropagation();toggleOpen()" class="transition-all cursor-pointer text-gray-700 outline-hidden focus:outline-hidden dark:text-gray-400"
              [ngClass]="{'rotate-180':isOpen, 'cursor-not-allowed opacity-50': loading}" [attr.disabled]="loading ? true : null">
        <lucide-icon size="18" [name]="ChevronDownIcon"></lucide-icon>
      </button>
    </div>
  </div>

  <div class="w-full min-w-100 px-4">
    <div class="w-full min-w-100 px-4">
      @if (isOpen) {
        <div class="max-h-[400px] absolute top-full left-0 z-9999 w-full overflow-y-auto rounded-lg bg-white shadow-sm dark:bg-gray-900">
          @if (searchable) {
            <div (click)="$event.stopPropagation();"
                 class="w-full cursor-pointer rounded-t border-b border-gray-200 dark:border-gray-800 p-2 flex items-center gap-2">
              <div class="relative w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <lucide-icon size="16" [name]="SearchIcon" class="text-gray-500 dark:text-gray-400"></lucide-icon>
                </div>
                <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()"
                       [placeholder]="searchPlaceholder"
                       class="block w-full pl-10 text-sm font-medium text-gray-700 dark:text-gray-400 p-2 rounded border border-gray-300 dark:border-gray-700 focus:outline-none focus:ring-2 focus:ring-brand-300">
              </div>
            </div>
          }
          @if (allowCreate) {
            <div (click)="$event.stopPropagation();"
                 class="hover:bg-brand-100 w-full cursor-pointer rounded-t border-b border-gray-200 dark:border-gray-800 p-2 flex items-center gap-2">
              <input type="text" [(ngModel)]="newOption" placeholder="Enter new value"
                     [placeholder]="createPlaceholder"
                     class="block w-full text-sm font-medium text-gray-700 dark:text-gray-400 p-2 rounded border border-gray-300 dark:border-gray-700">
              <app-button [label]="'Add'" [disabled]="!newOption || creating" [style]="'primary'" (click)="createOption()"></app-button>
            </div>
          }
          <div class="flex w-full flex-col">
            @if (options.length === 0) {
              <div class="w-full p-4 text-center text-gray-500 dark:text-gray-400">
                No matching options found
              </div>
            } @else {
              @for (option of options; track option.value) {
                <div (click)="$event.stopPropagation(); select(option.id)"
                     class="hover:bg-brand-100 w-full cursor-pointer rounded-t border-b border-gray-200 dark:border-gray-800">
                  <div [ngClass]="{'bg-brand-100': option.selected, }" class="relative flex w-full items-center border-l-2 border-transparent p-2 pl-2">
                    <div class="flex w-full items-center">
                      <div class="mx-2 leading-6 text-gray-800 dark:text-white/90">{{ option.label }}</div>
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>

@if (control && control.invalid && (control.dirty || control.touched)) {
  <div class="text-red-600 text-sm mt-1">
    @if (control.errors?.['required']) {
      <div>This field is required</div>
    }
    @if (control.errors?.['pattern']) {
      <div>Invalid value</div>
    }
  </div>
}
